import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoLocation = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Location</title>
    <path
      d="M28.287 3.026c.166.04.317.124.44.244a.944.944 0 0 1 .225.962l-8.035 24.126a.946.946 0 0 1-.894.642h-.047a.942.942 0 0 1-.877-.717l-2.91-12.408-12.434-2.972A.943.943 0 0 1 3 12.035a.945.945 0 0 1 .64-.943l24.143-8.049a.94.94 0 0 1 .503-.017Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIcoLocation;
